const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_date', 'utm_term'];

const readUtmParams = function() {
  const params = {};
  const queryString = window.location.search.substring(1);
  if (!queryString.includes('utm')) {
    return params;
  }

  const regex = /([^&=]+)=([^&]*)/g;
  let match;
  while ((match = regex.exec(queryString)) !== null) {
    const key = decodeURIComponent(match[1]);
    if (UTM_PARAMS.includes(key)) {
      params[key] = decodeURIComponent(match[2]);
    }
  }

  return params;
};

const setCookie = function(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value || ''}; expires=${date.toUTCString()}; path=/`;
};

const identifyUtm = function(params) {
  const amplitude = window.amplitude;
  if (typeof amplitude?.Identify !== 'function' || typeof amplitude.identify !== 'function') {
    return;
  }

  const identify = new amplitude.Identify();
  UTM_PARAMS.forEach((key) => {
    const value = params[key];
    if (!value) {
      return;
    }
    identify.set(key, value);
    identify.setOnce(`initial_${key}`, value);
  });
  amplitude.identify(identify);
};

export const captureUtmFromUrl = function() {
  const params = readUtmParams();
  if (Object.keys(params).length === 0) {
    return;
  }

  Object.entries(params).forEach(([key, value]) => setCookie(key, value, 365));
  identifyUtm(params);
};

export const startUtmCapture = function() {
  // First paint: `turbo:load` already fired before the old async chunk ran (TW-2913).
  captureUtmFromUrl();
  document.addEventListener('turbo:load', captureUtmFromUrl);
};
